import { getAxiosClient } from "../../axios-client";
import { WarehousesInsuranceDeleteBody, WarehousesInsuranceDeleteResponse } from "./types";

const axiosClient = getAxiosClient();
// export const addWarehousesInsurance = async (body: WarehousesInsuranceBody) => {
//   return await axiosClient.ax
//   .post<WarehousesInsuranceResponse>("/WarehousesInsurance/Add", body)
// };
export const deleteWarehousesInsurance = async (body: WarehousesInsuranceDeleteBody) => {
    return await axiosClient.ax
    .delete<WarehousesInsuranceDeleteResponse>("/WarehousesInsurance/Delete", {data:body})
  };
  